import { ref } from 'vue'

// Preferencia global de tiles, compartida por TODOS los mapas de la app
// (los internos vía store/map.js y los públicos vía useMapTiles.js).
// Estado singleton a nivel de módulo + persistencia en localStorage.

const GOOGLE_KEY = 'map:useGoogle'
const SATELLITE_KEY = 'map:satellite'

const googleEnabled = ref(localStorage.getItem(GOOGLE_KEY) !== 'false')
const satelliteEnabled = ref(localStorage.getItem(SATELLITE_KEY) === 'true')

const setGoogleEnabled = (val) => {
  googleEnabled.value = !!val
  localStorage.setItem(GOOGLE_KEY, googleEnabled.value ? 'true' : 'false')
}

const setSatelliteEnabled = (val) => {
  satelliteEnabled.value = !!val
  localStorage.setItem(SATELLITE_KEY, satelliteEnabled.value ? 'true' : 'false')
}

export function useMapPrefs() {
  return { googleEnabled, setGoogleEnabled, satelliteEnabled, setSatelliteEnabled }
}
